const saveDateDictumCommittee = async(params) => {
	const { protocol_id, committee_id, date } = params
	
	try {
		return await axios.post(`/committee/date-dictum`, {
			protocol_id,
			committee_id,
			date,
		})
	} catch(e) {
		throw e
	}
}

const saveCommitteeDictum = async(params) => {
	try {
		return await axios.post(`/committee/dictum`, params, {
			headers: {
				'Conten-Type': 'multipart/form-data',
			},
		})
	} catch(e) {
		throw e
	}
}

const fetchDateDictumCommittee = async(params) => {
	try {
		return await axios.get(`/committee/date-dictum`, {
			params,
		})
	} catch(e) {
		throw e
	}
}

const fetchCommittees = async(params) => {
	try {
		return await axios.get(`/committees`, {
			params,
		})
	} catch(e) {
		throw e
	}
}

const fetchReviewersCommittee = async(params) => {
	try {
		return await axios.get(`/committee/reviewers`, {
			params,
		})
	} catch(e) {
		throw e
	}
}

const fetchDictumTypes = async(params) => {
	try {
		return await axios.get(`/committee/dictum-types`, {
			params,
		})
	} catch(e) {
		throw e
	}
}

const fetchDictums = async(params) => {
	try {
		return await axios.get(`/committee/dictums`, {
			params,
		})
	} catch(e) {
		throw e
	}
}

const fetchAssignedReviewers = async(params) => {
	try {
		return await axios.get(`/committee/assigned-reviewers`, {
			params,
		})
	} catch(e) {
		throw e
	}
}

const fetchAssignedReviewerDictums = async(params) => {
	try {
		return await axios.get(`/reports/assigned-reviewers-dictums-report`, {
			params,
		})
	} catch(e) {
		throw e
	}
}

const fetchProtocolTaskAdvance = async(params) => {
	try {
		return await axios.get(`/committee/advances`, {
			params,
		})
	} catch(e) {
		throw e
	}
}

const addReviewerCommittee = async(params) => {
	const { protocol, researcher, committee } = params
	
	try {
		return await axios.post(`/committee/reviewer/protocol/${protocol}`, {
			user_id: researcher,
			committee_id: committee,
		})
	} catch(e) {
		throw e
	}
}

const cancelProtocolCommittee = async(params) => {
	try {
		return await axios.post(`/committee/protocol/${params.get('protocol_id')}/cancel`, params, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
	} catch(e) {
		throw e
	}
}

const fetchReviewerInvitation = async({ protocol, user, committee }) => {
	try {
		return await axios.get(`/committee/protocol/${protocol.id}/reviewer/${user.id}/invitation`, {
			params: {
				committee: committee.id,
			},
		})
	} catch(e) {
		throw e
	}
}

const fetchReviewerDictums = async({ protocol, user, committee }) => {
	try {
		return await axios.get(`/committee/protocol/${protocol.id}/reviewer/${user.id}/dictums`, {
			params: {
				committee: committee.id,
			},
		})
	} catch(e) {
		throw e
	}
}

const replyReviewerInvite = async({ protocol, user, comments, committee, reply }) => {
	try {
		return await axios.post(`/committee/protocol/${protocol.id}/reviewer/${user.id}/reply`, {
			reply,
			comments,
			committee: committee.id,
		})
	} catch(e) {
		throw e
	}
}

const saveReviewerDictum = async(payload) => {
	const { model, user, ...params } = payload
	
	try {
		return await axios.post(`/committee/protocol/${model.id}/reviewer/${user.id}/dictum`, { ...params })
	} catch(e) {
		throw e
	}
}

const cancelReviewer = async({ protocol, committee, user }) => {
	try {
		return await axios.patch(`/committee/protocol/${protocol.id}/reviewer/${user}`, {
			committee: committee.id,
		})
	} catch(e) {
		throw e
	}
}

const resendInvitation = async({ protocol, committee, user }) => {
	try {
		return await axios.post(`/committee/protocol/${protocol.id}/reviewer/${user}/resend`, {
			committee: committee.id,
		})
	} catch(e) {
		throw e
	}
}

const createReviewerDictumTask = async({ protocol, committee, user }) => {
	try {
		return await axios.post(`/committee/protocol/${protocol}/reviewer/${user}/task/create`, {
			committee,
		})
	} catch(e) {
		throw e
	}
}

export {
	saveDateDictumCommittee,
	saveCommitteeDictum,
	fetchDateDictumCommittee,
	fetchCommittees,
	fetchReviewersCommittee,
	fetchDictumTypes,
	fetchDictums,
	fetchAssignedReviewers,
	addReviewerCommittee,
	cancelProtocolCommittee,
	fetchAssignedReviewerDictums,
	fetchProtocolTaskAdvance,
	fetchReviewerInvitation,
	fetchReviewerDictums,
	replyReviewerInvite,
	saveReviewerDictum,
	cancelReviewer,
	resendInvitation,
	createReviewerDictumTask,
}
